import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--regularizations--certificates--dashboard`
  }

  doCertificatesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--regularizations--certificates--index">Bancos</div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--regularizations--certificates--save operations--products--clinics--regularizations--certificates--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--submenu`).dashboardToggleBtn(`CERTIFICADO DIGITAL`)

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--certificates--index`).permission = `medclinic_regularization_certificates`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--certificates--show`).permission = `medclinic_regularization_certificates`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--certificates--save`).permission = `medclinic_regularization_certificates`

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--certificates--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--certificates--show`).doViewHtml()
    }) 
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
